import React from 'react';
import PropTypes from 'prop-types';
import * as userTypes from '../../../redux/futures/user/types';
import Input from '../../../components/Input';
import _ from 'lodash';

class ActiveAiCall extends React.Component {
    static propTypes = {
        currentUser: PropTypes.object,
        activeAiCall: PropTypes.func,
        user: PropTypes.object
    }

    constructor(props) {
        super(props);
        this.state = {
            currentUser: {
                _id: "",
                email: "",
                fullname: ""
            },
            formData: {
                name: "",
                acc_campaign_id: "",
                campaign_type: "PERSONALIZED",
                phone_type: "RANDOM",
                list_params: []
            },
            loading: false,
            classNormal: "ladiui button primary",
            classLoading: "ladiui loader button primary",
            classApply: "ladiui button primary"
        };
        this.inputsRef = new Set();
        this.ref = React.createRef();
    }

    componentDidMount() {
        // Initialize component
    }

    componentDidUpdate() {
        window.LadiUI.init();
    }

    componentWillReceiveProps(nextProps) {
        if (this.props !== nextProps) {
            if (nextProps.currentUser && this.state.currentUser !== nextProps.currentUser && nextProps.currentUser._id && nextProps.currentUser._id !== "") {
                this.setState({
                    currentUser: nextProps.currentUser
                });
            }

            if (nextProps.user.action === userTypes.ACTIVE_AI_CALL) {
                this.setState({
                    loading: false,
                    classApply: this.state.classNormal
                });

                if (nextProps.user.status) {
                    const _self = this;
                    window.LadiUI.toastr('success', '', nextProps.user.message);
                    setTimeout(function () {
                        window.LadiUI.closeModal(_self.ref.current);
                        _self.resetForm();
                    }, 1000);
                } else {
                    window.LadiUI.toastr('error', '', nextProps.user.message);
                }
            }
        }
    }

    onChangeInput = (event) => {
        this.setState({
            formData: {
                ...this.state.formData,
                [event.target.name]: event.target.value
            }
        });
    }

    onChangeListParam = (index, field, value) => {
        const { list_params } = this.state.formData;
        const updatedParams = [...list_params];
        updatedParams[index] = {
            ...updatedParams[index],
            [field]: value
        };

        this.setState({
            formData: {
                ...this.state.formData,
                list_params: updatedParams
            }
        });
    }

    addListParam = () => {
        const { list_params } = this.state.formData;
        this.setState({
            formData: {
                ...this.state.formData,
                list_params: [...list_params, { type: "STRING", name: "" }]
            }
        });
    }

    removeListParam = (index) => {
        const { list_params } = this.state.formData;
        const updatedParams = list_params.filter((_, i) => i !== index);

        this.setState({
            formData: {
                ...this.state.formData,
                list_params: updatedParams
            }
        });
    }

    submit = () => {
        // Validate
        let errors = [];
        const inputsRef = _.compact(Array.from(this.inputsRef));
        _.map(inputsRef, ref => {
            if (ref.validate) {
                errors = errors.concat(ref.validate());
            }
        });

        _.compact(errors);
        if (errors.length > 0) {
            const errorMessage = errors.join("<br/>");
            window.LadiUI.toastr('error', '', errorMessage);
            return;
        }

        const { formData, currentUser } = this.state;

        // Validate list_params
        const hasEmptyParams = formData.list_params.some(param => !param.name.trim());
        if (hasEmptyParams) {
            window.LadiUI.toastr('error', '', 'Tất cả các tham số trong danh sách phải có tên');
            return;
        }

        const jsonData = {
            ladi_uid: currentUser._id,
            name: formData.name,
            acc_campaign_id: formData.acc_campaign_id,
            campaign_type: formData.campaign_type,
            phone_type: formData.phone_type,
            list_params: formData.list_params
        };

        this.props.activeAiCall(jsonData);

        this.setState({
            loading: true,
            classApply: this.state.classLoading
        });
    }

    resetForm = () => {
        this.setState({
            formData: {
                name: "",
                acc_campaign_id: "",
                campaign_type: "PERSONALIZED",
                phone_type: "RANDOM",
                list_params: []
            }
        });
    }

    render() {
        const { formData, currentUser } = this.state;
        const title = 'Kích hoạt AI Call: Tạo cấu hình AI Call cho người dùng';
        this.inputsRef = new Set();

        return (
            <div ref={this.ref} id="modal-active-ai-call" className="ladiui-modal fade" tabIndex={-1} data-dismiss="modal-active-ai-call">
                <div className="ladiui-modal-content">
                    <div className="ladiui-modal-header">
                        <button type="button" className="ladiui-close-modal" data-dismiss="modal-active-ai-call">
                            <i className="ladi-icon icon-e-remove" data-dismiss="modal-active-ai-call" />
                        </button>
                        <h3>{title}</h3>
                    </div>
                    <div className="ladiui-modal-body" style={{ overflow: "unset" }}>
                        <form>
                            <div className="ladiui-tab-content">
                                <div className="ladiui-row">
                                    <div className="col-50">
                                        <div className="ladiui form-group">
                                            <label className="ladiui-label">Email</label>
                                            <input
                                                name="email"
                                                className="ladiui input"
                                                value={currentUser.email}
                                                disabled="disable"
                                            />
                                        </div>
                                    </div>
                                    <div className="col-50">
                                        <div className="ladiui form-group">
                                            <label className="ladiui-label">Họ tên</label>
                                            <input
                                                name="fullname"
                                                className="ladiui input"
                                                value={currentUser.fullname}
                                                disabled="disable"
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div className="ladiui-row">
                                    <div className="col-50">
                                        <div className="ladiui form-group">
                                            <label className="ladiui-label">Tên</label>
                                            <Input
                                                ref={(ref) => this.inputsRef.add(ref)}
                                                name="name"
                                                validationName="Tên"
                                                placeholder="Nhập tên"
                                                value={formData.name}
                                                onChange={this.onChangeInput}
                                                validations={{ isRequired: true }}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-50">
                                        <div className="ladiui form-group">
                                            <label className="ladiui-label">Acc Campaign ID</label>
                                            <Input
                                                ref={(ref) => this.inputsRef.add(ref)}
                                                name="acc_campaign_id"
                                                validationName="Acc Campaign ID"
                                                placeholder="Nhập Acc Campaign ID"
                                                value={formData.acc_campaign_id}
                                                onChange={this.onChangeInput}
                                                validations={{ isRequired: true }}
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div className="ladiui-row">
                                    <div className="col-50">
                                        <div className="ladiui form-group">
                                            <label className="ladiui-label">Campaign Type</label>
                                            <div className="ladiui-select-options">
                                                <span className="ladiui-select-init">{formData.campaign_type}</span>
                                                <input type="hidden" name="select" defaultValue />
                                                <ul>
                                                    <li className="select-item" onClick={() => this.onChangeInput({ target: { name: 'campaign_type', value: 'PERSONALIZED' } })}>
                                                        <a data-value="PERSONALIZED">PERSONALIZED</a>
                                                    </li>
                                                    <li className="select-item" onClick={() => this.onChangeInput({ target: { name: 'campaign_type', value: 'FIXED' } })}>
                                                        <a data-value="FIXED">FIXED</a>
                                                    </li>
                                                    <li className="select-item" onClick={() => this.onChangeInput({ target: { name: 'campaign_type', value: 'OTP' } })}>
                                                        <a data-value="OTP">OTP</a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-50">
                                        <div className="ladiui form-group">
                                            <label className="ladiui-label">Phone Type</label>
                                            <div className="ladiui-select-options">
                                                <span className="ladiui-select-init">{formData.phone_type}</span>
                                                <input type="hidden" name="select" defaultValue />
                                                <ul>
                                                    <li className="select-item" onClick={() => this.onChangeInput({ target: { name: 'phone_type', value: 'RANDOM' } })}>
                                                        <a data-value="RANDOM">RANDOM</a>
                                                    </li>
                                                    {/* <li className="select-item" onClick={() => this.onChangeInput({ target: { name: 'phone_type', value: 'FIXED' } })}>
                                                        <a data-value="FIXED">FIXED</a>
                                                    </li> */}
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="ladiui form-group">
                                    <label className="ladiui-label">Danh sách tham số</label>
                                    <div className="list-params-container">
                                        {formData.list_params.map((param, index) => (
                                            <div key={index} className="ladiui-row" style={{ marginBottom: '10px', alignItems: 'center', display: 'flex' }}>
                                                <div className="col-50">
                                                    <input
                                                        type="text"
                                                        className="ladiui input"
                                                        value={param.name}
                                                        onChange={(e) => this.onChangeListParam(index, 'name', e.target.value)}
                                                        placeholder="Tên tham số"
                                                    />
                                                </div>
                                                <div className="ladiui-row col-50" style={{ display: 'flex' }}>
                                                    <div className="col-30">
                                                        <input
                                                            type="text"
                                                            className="ladiui input"
                                                            value="STRING"
                                                            disabled="disable"
                                                            style={{ backgroundColor: '#f5f5f5', color: '#666' }}
                                                        />
                                                    </div>
                                                    <div className="col-30">
                                                        <button
                                                            type="button"
                                                            className="ladiui button danger"
                                                            onClick={() => this.removeListParam(index)}
                                                            style={{ padding: '8px 12px' }}
                                                        >
                                                            <i className="ladi-icon icon-e-remove" />
                                                        </button>
                                                    </div>
                                                </div>

                                            </div>
                                        ))}
                                        <button
                                            type="button"
                                            className="ladiui button primary"
                                            onClick={this.addListParam}
                                            style={{ marginTop: '10px' }}
                                        >
                                            <i className="ladi-icon icon-c-add" style={{ marginRight: '5px' }} />
                                            Thêm tham số
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                    <div className="ladiui-modal-footer">
                        <button className="ladiui button secondary close-modal icon" data-dismiss="modal-active-ai-call">
                            <i className="ladi-icon icon-e-remove" data-dismiss="modal-active-ai-call" />Đóng
                        </button>
                        <button
                            ref={this.ref}
                            className={this.state.classApply}
                            onClick={this.submit}
                            disabled={this.state.loading}
                        >
                            <i className="ladi-icon icon-floppy-disk" style={{ display: (this.state.loading) ? 'none' : '', paddingRight: '5px' }}></i>
                            Kích hoạt AI Call
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}

export default ActiveAiCall;
